import BResourcePage from "../../../components/resources/BResourcePage";

function UsersPage() {
  return (
    <BResourcePage
      title={"Benutzer"}
      url={"/Customers"}
      isCustomerPage="isCustomerPage"
      fieldsVisibleAtBeginning={[
        "id",
        "email",
        "firstName",
        "lastName",
        "zipCode",
        "phoneNumber",
        "brokerName",
      ]}
    />
  );
}

export default UsersPage;
